import { Component, Input } from '@angular/core';
import {
  uppercaseConverter,
  AutocompleteDirective,
  IsInvalidPipe,
} from '@innogy/utils-deprecated';
import { FormGroupState } from 'ngrx-forms';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import {
  ProgressiveFormStepWrapperComponent,
  ProgressiveFormBodyDirective,
  ProgressiveFormSummaryDirective,
} from '@innogy/shared/progressive-form';
import { TextComponent, InputErrorComponent } from '@innogy/common-ui/forms';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CSMaskDirective } from '@legacy/utils-contentsquare';

import type { FormPaymentDetails } from './state/progressive-payment-details-form.reducer';
import { ProgressivePaymentDetailsFormRendering } from './progressive-payment-details-form.rendering';

@Component({
  selector:
    'wl-progressive-payment-details-form[rendering][step][stepName][formState][progressiveFormSelectorKey]',
  templateUrl: './progressive-payment-details-form.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    ProgressiveFormStepWrapperComponent,
    ProgressiveFormBodyDirective,
    TextComponent,
    AutocompleteDirective,
    InputErrorComponent,
    AutomationIdDirective,
    ProgressiveFormSummaryDirective,
    CSMaskDirective,
    JssModule,
    IsInvalidPipe,
  ],
})
export class ProgressivePaymentDetailsFormComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabels?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: ProgressivePaymentDetailsFormRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stepName!: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() step!: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState!: FormGroupState<FormPaymentDetails>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() progressiveFormSelectorKey!: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isReadonly = false;

  _uppercaseConverter = uppercaseConverter;
}
